import { useSelectorTyped } from "../../../../../common/redux/store";
import YesNoChoices from "../../../data/yes-no-choice";
import { getGcpProjectNames, prefixApplicationNameToGitHubRepos } from "../../../data/common-functions";

export default function useInfraConfigReviewController() {
  const infraConfig = useSelectorTyped((state) => state.getStartedPage.gits.infraConfig);
  const projectName = useSelectorTyped((state) => state.getStartedPage.gits.basicInfo.projectName);

  const isGcpProjectRequested = () => infraConfig.isHostingServiceNeeded === YesNoChoices.YES;

  const isGithubRepoRequested = () => infraConfig.isCodeRepositoryNeeded === YesNoChoices.YES;

  /** User asked for repos but the team has no mapped GitHub org (infra step shows the mapping error). */
  const isGithubReposRequestedWithoutMappedOrg = () =>
    isGithubRepoRequested() && !infraConfig.githubOrganisation?.trim();

  const isInfraRequested = () => infraConfig.isCodeRepositoryNeeded === YesNoChoices.YES
    || infraConfig.isHostingServiceNeeded === YesNoChoices.YES;

  const getGithubRepoRequestedStatus = () => {
    if (isGithubReposRequestedWithoutMappedOrg()) {
      return "Not requested";
    }
    return isGithubRepoRequested() ? "Requested" : "Not requested";
  };

  const getGcpProjectRequestedStatus = () => isGcpProjectRequested() ? "Requested" : "Not requested";

  const getCircleCiRequestedStatus = () => infraConfig.isCiCdPipelineNeeded === YesNoChoices.YES ? "Requested" : "Not requested";

  const getGithubOrganisationStatus = () => {
    if (isGithubReposRequestedWithoutMappedOrg()) {
      return "Not requested";
    }
    return infraConfig.githubOrganisation;
  };

  const getGithubRepositoryFullNames = () => {
    if (isGithubReposRequestedWithoutMappedOrg()) {
      return ["Not requested"];
    }
    return prefixApplicationNameToGitHubRepos(infraConfig.githubRepos, projectName);
  };

  return {
    infraConfig,
    isInfraRequested,
    isGcpProjectRequested,
    isGithubRepoRequested,
    getCircleCiRequestedStatus,
    getGithubOrganisationStatus,
    getGithubRepoRequestedStatus,
    getGcpProjectRequestedStatus,
    getGcpProjectNames: () => getGcpProjectNames(infraConfig.gcpProjects),
    getGithubRepositoryFullNames,
  };
}
